import React from "react";
import { Box, H3, Button } from "@atoms";
import { Link } from "@reach/router";
import { RailsUrl } from "@services";
import { useStoreAppValue } from "@hooks";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {}

// == Constants ============================================================

NearbyListEmpty.defaultProps = {};

// == Component ============================================================

export default function NearbyListEmpty(props: IProps) {
  const { campaignId } = useStoreAppValue();
  return (
    <Box textAlign="center" mt={4}>
      <H3 mb={3}>There are no matching stores nearby</H3>
      <Link to={RailsUrl.brandsUrl({ campaignId })}>
        <Button>View All Stores</Button>
      </Link>
    </Box>
  );
}

// == Styles ===============================================================
